import { render, staticRenderFns } from "./usergroup-monitoring-service-order.vue?vue&type=template&id=74b6b6d2&scoped=true"
import script from "./usergroup-monitoring-service-order.vue?vue&type=script&lang=js"
export * from "./usergroup-monitoring-service-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6b6d2",
  null
  
)

export default component.exports